var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-body"},[_c('div',[_c('span',{staticClass:"icon-wx"}),_c('h3',[_vm._v("仅限认证公众号使用")])])])}]

export { render, staticRenderFns }